// import { useSelector } from "react-redux";
import apiRequest from "../apis/api-request";

//   const accessToken = useSelector((state) => state.leads.leadData.token);

const leadLoginService = {
   
     leadLogin: async (credentials) => {
        return apiRequest({
            method: "POST",
            url: '/lead/login',
            data: {
                email: credentials.email,
                password: credentials.password
            }
        });
    },

    forgotpassword: async (data) => {
        return apiRequest({
            method: "POST",
            url: '/lead/forgot-password',
            data: {
                email: data.email
            }
        });
    },

    // Additional methods you might need
    // changePassword: async (passwordData) => {
    //     console.log("apidata",passwordData )
    //     return apiRequest({
    //         method: "POST",
    //         url: '/lead/change-password',
    //         data: {
    //             currentPassword: passwordData.currentPassword,
    //             newPassword: passwordData.newPassword
    //         },
    //         headers: {
    //     //   Authorization: "Bearer " + accessToken
    //     Authorization: `Bearer ${passwordData.accessToken}`
    //     }
    //     });
    // },
    changePassword: async (passwordData) => {
    try {
        const response = await apiRequest({
            method: "POST",
            url: '/lead/change-password',
            data: {
                currentPassword: passwordData.currentPassword,
                newPassword: passwordData.newPassword
            },
            headers: {
                Authorization: `Bearer ${passwordData.accessToken}`
            }
        });
        
        // If response status indicates error, throw it
        if (response.status >= 400) {
            throw response;
        }
        
        return response;
    } catch (error) {
        // Ensure the error is properly propagated
        throw error;
    }
},

     getSessions: async () => {
        return apiRequest({
            method: "GET",
            url: '/session/table-list'
        });
    },

    getSpeakers: async () => {
        return apiRequest({
            method: "GET",
            url: '/speakers/table-list'
        });
    },

    getVenues: async () => {
        return apiRequest({
            method: "GET",
            url: '/venue/table-list'
        });
    },

    getSessionSponsors: async () => {
        return apiRequest({
            method: "GET",
            url: '/session/sponsor/table-list'
        });
    },

    getSponsors: async () => {
        return apiRequest({
            method: "GET",
            url: '/sponsor/table-list'
        });
    },

}

export default leadLoginService;